import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** magnifying glass. Decorative line icon; always pair with a visible text label. */
export function SearchIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <circle cx="11" cy="11" r="6.5" />
      <path d="M21 21l-4.4-4.4" />
    </IconSvg>
  )
}
